import axios from "axios";
import { getToken } from "../auth";


export const BASE_URL = 'http://localhost/billing_admin/api/';
export const myAxios = axios.create({
    baseURL:BASE_URL,
});


// const token = getToken()
// console.log(token);

// axios.defaults.headers.common['Authorization']=`Bearer ${token}`
export const privateAxios = axios.create({
    baseURL:BASE_URL
})

privateAxios.interceptors.request.use((config) =>{
        const token = getToken()
        
        if (token) {
            console.log(token)
            //config.headers.common.Authorization=`Bearer ${token}`
            config.headers.Authorization =`Bearer ${token}`

            console.log(config);
        } 
        return config
    },(error) => Promise.reject(error)
);